'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  if (sessionStorage.getItem('version') !== _config2.default.version) {
    sessionStorage.setItem('version', _config2.default.version);
    location.reload(true);
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/validators/common/Version.js
// module id = 1752
// module chunks = 0